import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch } from "react-icons/md";
import Button from "react-bootstrap/Button";

import { Image } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";

import add from "../../assets/add.svg";
import remove from "../../assets/remove.svg";
import ProgressBar from "react-bootstrap/ProgressBar";
import Econimic from "../../assets/economic.svg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import iicon from "../../assets/i.svg";

import Loader from "../Loader/Loader";
import { ManageCouponsAPI } from "./../API/Coupons/ManageCoupons";
import { DeleteCoupons } from "./../API/Coupons/DeleteCoupons";
import { UpdateStatus } from "./../API/Coupons/UpdateStatus";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import Pagination from "../Pagination/Pagination";
import swal from "sweetalert";
import { AutoPublishAPI } from "../API/Coupons/AutoPublish";
import NoDataText from "../NoDataText";
import SearchBarResults from "../Search/SearchBarResults";
import { Switch } from "antd";
import { updateFeatureCouponsAPI } from "../API/Coupons/updateFeatureCoupons";
import { FormatDateShortMonth } from "../../Utils/DateFormatter";

const ManageCoupons = () => {
  const [loading, setLoading] = useState(false);
  const [TableRows, setTableRows] = useState([]);
  const [globalTableRows, setglobalTableRows] = useState([]);

  // checkbox
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  // AutoPublish
  const [AutoPublish, setAutoPublish] = useState([]);
  const [checkAutoPublish, setcheckAutoPublish] = useState(false);
  // search
  const [searchValue, setsearchValue] = useState("");
  // err
  const [ShowTable, setShowTable] = useState(false);
  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  // global
  const [globalTotalPageCount, setGlobalTotalPageCount] = useState(0);
  const [globalLimit, setGlobalLimit] = useState(0);
  // sort
  const [flag, setFlag] = useState({
    coupon_name: 0,
    bi_name: 0,
    coupon_limit: 0,
    coupon_created_at: 0,
    coupon_end_date: 0,
    status_name: 0,
  });

  const cityId = localStorage.getItem("cityId");
  // feature-status
  const [featureStatus, setFeatureStatus] = useState({});
  const [disabled, setDisabled] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    getAutoPublishStatus();
  }, []);

  const getAutoPublishStatus = async () => {
    setLoading(true);
    const data = {
      switch: "",
      mms_city_id: parseInt(cityId),
      flag: "coupon",
    };
    const Response = await AutoPublishAPI(data, () => {
      navigate("/");
    });
    if (Response.status === 429) {
      swal({
        text: Response.message,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(false);
    } else if (Response.data?.[0]?.status == 1) {
      setcheckAutoPublish(true);
      setLoading(false);
    } else {
      setcheckAutoPublish(false);
      setLoading(false);
    }
  };

  // pagination / fetch
  const pageChange = async () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      offset: pageNumber,
    };
    const coupondetailData = await ManageCouponsAPI(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      swal({
        text: coupondetailData.message,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(false);
    } else if (
      coupondetailData.data?.length === 0 ||
      coupondetailData.message === "No Data Available"
    ) {
      setShowTable(true);
      setTableRows([]);
      setIsCheck([]);
      setIsCheckAll(false);
      setLoading(false);
    } else {
      setTableRows(coupondetailData.data);
      setglobalTableRows(coupondetailData.data);
      setTotalPageCount(coupondetailData.total_page_count);
      setLimit(coupondetailData.limit);
      setGlobalTotalPageCount(coupondetailData.total_page_count);
      setGlobalLimit(coupondetailData.limit);
      setIsCheck([]);
      setIsCheckAll(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    pageChange();
  }, [pageNumber]);

  // Keep select-all sync with individual checkbox selections
  useEffect(() => {
    if (TableRows.length > 0 && isCheck.length === TableRows.length) {
      setIsCheckAll(true);
    } else {
      setIsCheckAll(false);
    }
  }, [isCheck, TableRows]);

  // checkbox - header
  const handleSelectAll = () => {
    const nextCheckAll = !isCheckAll;
    setIsCheckAll(nextCheckAll);
    if (nextCheckAll) {
      setIsCheck(TableRows.map((li) => li.city_coupon_id));
    } else {
      setIsCheck([]);
    }
  };

  // checkbox - row
  const handleClick = (e, id) => {
    const { checked } = e.target;
    if (checked) {
      setIsCheck((prev) => [...prev, id]);
    } else {
      setIsCheck((prev) => prev.filter((item) => item !== id));
    }
  };

  // update status (individual row)
  const handleChangeDropDown = (e, key) => {
    const statusVal = parseInt(e.target.value);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      coupon_id: [TableRows[key].city_coupon_id],
      status_id: statusVal,
    };

    swal({
      title: `Are you sure you want to update status of "${TableRows[key].coupon_name}"?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        setLoading(true);
        const Response = await UpdateStatus(data, () => {
          navigate("/");
        });
        if (Response.success === true) {
          swal({
            title: `"${TableRows[key].coupon_name}" status has been updated successfully!`,
            icon: "success",
            buttons: "Ok",
          }).then((isOk) => {
            if (isOk) {
              pageChange();
            }
          });
        } else {
          setLoading(false);
          swal({
            text: "Please wait...",
            icon: "error",
            buttons: "Ok",
          });
          window.location.reload(false);
        }
      }
    });
  };

  // update status (bulk / selected)
  const handleChangeDropDownTop = (e) => {
    if (!e.target.value || e.target.value === "Select Status") return;
    const statusVal = parseInt(e.target.value);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      coupon_id: isCheck,
      status_id: statusVal,
    };

    swal({
      title: `Are you sure you want to update status for selected coupon(s)?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        setLoading(true);
        const Response = await UpdateStatus(data, () => {
          navigate("/");
        });
        if (Response.success === true) {
          swal({
            title: `Selected coupon status has been updated successfully!`,
            icon: "success",
            buttons: "Ok",
          }).then((isOk) => {
            if (isOk) {
              setIsCheck([]);
              setIsCheckAll(false);
              pageChange();
            }
          });
        } else {
          setLoading(false);
          swal({
            text: "Please wait...",
            icon: "error",
            buttons: "Ok",
          });
          pageChange();
        }
      }
    });
  };

  // Delete
  const handleDelete = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "delete",
      coupon_id: isCheck,
    };

    swal({
      title: `Are you sure you want to delete selected coupon(s)?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        setLoading(true);
        const deleteRes = await DeleteCoupons(data, () => {
          navigate("/");
        });
        if (deleteRes.status === 429) {
          swal({
            text: `${deleteRes.message}`,
            icon: "error",
            buttons: "Ok",
            dangerMode: false,
          });
          setLoading(false);
        } else {
          swal({
            title: `Selected coupon has been deleted successfully!`,
            icon: "success",
            buttons: false,
          });
          setIsCheck([]);
          setIsCheckAll(false);
          setTimeout(() => {
            pageChange();
          }, 1000);
        }
      }
    });
  };

  const handleAutoPublish = async (value) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      switch: value === false ? 1 : 0,
      mms_city_id: parseInt(cityId),
      flag: "coupon",
    };

    swal({
      title: `Are you sure you want to update auto-publish status?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        setLoading(true);
        const Response = await AutoPublishAPI(data, () => {
          navigate("/");
        });
        if (Response.status === 429) {
          swal({
            text: Response.message,
            icon: "error",
            buttons: "Ok",
          });
          setLoading(false);
        } else if (Response.success === true) {
          setcheckAutoPublish(!checkAutoPublish);
          setLoading(false);
          swal({
            title: `Auto-publish status has been updated successfully!`,
            icon: "success",
            buttons: "Ok",
          });
        }
      }
    });
  };

  // search
  const handleSearchInput = (e) => {
    setsearchValue(e.target.value);
    if (e.target.value.length === 0) {
      setShowTable(false);
      setTableRows(globalTableRows);
      setTotalPageCount(globalTotalPageCount);
      setLimit(globalLimit);
      setIsCheck([]);
      setIsCheckAll(false);
    }
  };

  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");

    const data = {
      mms_city_id: parseInt(cityId),
      search_value: searchValue,
      offset: searchValue ? 0 : pageNumber,
    };
    const coupondetailData = await ManageCouponsAPI(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      swal({
        text: coupondetailData.message,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(false);
    } else if (coupondetailData.success === false) {
      setShowTable(true);
      setLoading(false);
      setTableRows([]);
      setIsCheck([]);
      setIsCheckAll(false);
    } else {
      setShowTable(false);
      setTableRows(coupondetailData.data);
      setTotalPageCount(coupondetailData.total_page_count);
      setLimit(coupondetailData.limit);
      setIsCheck([]);
      setIsCheckAll(false);
      setLoading(false);
    }
  };

  // sort
  const handleSort = async (search, sortNo, colValue) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      offset: search ? 0 : pageNumber,
      search_value: search,
      column_name: colValue,
      sort_type: sortNo,
    };
    const coupondetailData = await ManageCouponsAPI(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      swal({
        text: coupondetailData.message,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(false);
    } else if (coupondetailData.message === "No Data Available") {
      setShowTable(true);
      setLoading(false);
      setIsCheck([]);
      setIsCheckAll(false);
    } else {
      setShowTable(false);
      setTableRows(coupondetailData.data);
      setglobalTableRows(coupondetailData.data);
      setTotalPageCount(coupondetailData.total_page_count);
      setLimit(coupondetailData.limit);
      setIsCheck([]);
      setIsCheckAll(false);
      setLoading(false);
    }
  };

  const HandleSortCol = (value) => {
    const nextFlag = (flag[value] + 1) % 3;
    setFlag((prev) => ({ ...prev, [value]: nextFlag }));
    handleSort(searchValue, nextFlag, value);
  };

  const handleFeatureStatus = async (
    checked,
    cityCouponId,
    businessID,
    marketplaceBusinessID,
    tabName,
  ) => {
    setFeatureStatus((prevState) => ({
      ...prevState,
      [cityCouponId]: checked,
    }));

    const payload = {
      mms_city_id: parseInt(cityId),
      business_id: parseInt(businessID),
      city_coupon_id: parseInt(cityCouponId),
      marketplace_business_id: parseInt(marketplaceBusinessID),
      action_key: checked === true ? "enable" : "disable",
    };

    if (tabName === "feature-toggle") {
      try {
        const response = await updateFeatureCouponsAPI(payload);
        if (response.status === 429) {
          swal({
            title: `${response.message}`,
            icon: "error",
            buttons: "OK",
          });
        } else if (response === false) {
          swal({
            title: `${response.message}`,
            icon: "error",
            buttons: "OK",
          });
        } else if (response.status === 400) {
          swal({
            title: `${response.message}`,
            icon: "error",
            buttons: "OK",
          }).then(() => {
            window.location.reload();
          });
        } else {
          pageChange();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      swal({
        title: `Are you sure you want to remove this coupon from the featured coupons?`,
        icon: "warning",
        buttons: true,
        dangerMode: false,
      }).then(async (willDelete) => {
        if (willDelete) {
          setLoading(true);
          try {
            const response = await updateFeatureCouponsAPI(payload);
            if (response.status === 429) {
              setLoading(false);
              swal({
                title: `${response.message}`,
                icon: "error",
                buttons: "OK",
              });
            } else if (response === false) {
              setLoading(false);
              swal({
                title: `${response.message}`,
                icon: "error",
                buttons: "OK",
              });
            } else if (response.status === 400) {
              swal({
                title: `${response.message}`,
                icon: "error",
                buttons: "OK",
              }).then(() => {
                window.location.reload();
              });
            } else {
              setLoading(false);
              swal({
                title: `Featured coupons has been removed successfully`,
                icon: "success",
                buttons: "Ok",
              });
            }
          } catch (error) {
            setLoading(false);
            console.error("Error fetching data:", error);
          }
        }
      });
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="manage-vou-main pt-3 pb-3 three-col-heading">
        <div className="d-flex">
          <div>
            {["top"].map((placement) => (
              <OverlayTrigger
                key={placement}
                placement={placement}
                overlay={
                  <Tooltip
                    id={`tooltip-${placement}`}
                    className="Tooltips"
                    style={{ opacity: "1" }}
                  >
                    Review status from 'New' to 'Published' or 'Declined' for
                    all coupons businesses create.
                  </Tooltip>
                }
              >
                <Image src={iicon} className="pt-1" width="20px" />
              </OverlayTrigger>
            ))}
          </div>
          <p className="page-maintitle pt-1">Manage Coupons</p>
        </div>
        <div className="">
          <InputGroup className="search-bar MVouchers">
            <InputGroup.Text>
              <MdSearch />
            </InputGroup.Text>
            <Form.Control
              className="search_feild"
              value={searchValue}
              onChange={handleSearchInput}
              onKeyPress={handleKeypress}
            />
            <Button variant="outline-secondary" onClick={handleSearch}>
              Search
            </Button>
          </InputGroup>
        </div>
        <div className="manage-vou d-flex">
          <div>
            {["top"].map((placement) => (
              <OverlayTrigger
                key={placement}
                placement={placement}
                overlay={
                  <Tooltip
                    id={`tooltip-${placement}`}
                    className="Tooltips"
                    style={{ opacity: "1" }}
                  >
                    Enable 'Auto-publish' to automatically publish all coupons
                    created by businesses without your approval.
                  </Tooltip>
                }
              >
                <Image src={iicon} className="pt-1" width="20px" />
              </OverlayTrigger>
            ))}
          </div>
          <p className="page-maintitle pt-1">Auto Publish </p>
          <Form.Check
            type="switch"
            id="custom-switch"
            className="switch-sec mt-1 pt-1"
            checked={checkAutoPublish}
            onChange={() => handleAutoPublish(checkAutoPublish)}
          />
        </div>
      </div>
      <SearchBarResults SearchValue={searchValue} />
      {isCheck.length !== 0 ? (
        <div className="d-flex">
          <Button
            className="green-btn width-150 p-0 mr-3"
            onClick={handleDelete}
          >
            Delete Selected
          </Button>
          <Form.Select
            aria-label="Default select example"
            className="table-select width-150 ml-3 status_select"
            onChange={handleChangeDropDownTop}
            value=""
          >
            <option value="" disabled>
              Select Status
            </option>
            {TableRows.length !== 0 &&
              TableRows[0]?.status_list.map((i) => (
                <option key={i.id} value={i.id}>
                  {i.status}
                </option>
              ))}
          </Form.Select>
        </div>
      ) : null}

      {/* table */}
      <div className="table-responsive-xl black-header">
        <table className="recentact-table mt-3 table ver-middle manage-vou-table manage-voulist-Table">
          <thead>
            <tr>
              <th className="radio-colors">
                <Form.Check
                  aria-label="select-all"
                  className="orange-checkbox"
                  onChange={handleSelectAll}
                  checked={isCheckAll}
                />
              </th>
              <th
                className="tableHead"
                onClick={() => HandleSortCol("coupon_name")}
                style={{ textAlign: "left", width: "300px" }}
              >
                <Button className="btn btn-primary sortIcon">
                  Coupons Name{" "}
                  {flag.coupon_name === 0 ? (
                    <FaSort />
                  ) : flag.coupon_name === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button>
              </th>

              <th
                onClick={() => HandleSortCol("bi_name")}
                style={{ textAlign: "left", width: "300px" }}
              >
                <Button className="btn btn-primary sortIcon">
                  Business Name{" "}
                  {flag.bi_name === 0 ? (
                    <FaSort />
                  ) : flag.bi_name === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button>
              </th>
              <th style={{ textAlign: "center" }}>Coupon Code</th>
              <th style={{ textAlign: "center" }}>Coupon Source</th>
              <th onClick={() => HandleSortCol("coupon_created_at")}>
                <Button
                  className="btn btn-primary sortIcon"
                  style={{ margin: "auto" }}
                >
                  Created Date{" "}
                  {flag.coupon_created_at === 0 ? (
                    <FaSort />
                  ) : flag.coupon_created_at === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button>
              </th>
              <th onClick={() => HandleSortCol("coupon_end_date")}>
                <Button
                  className="btn btn-primary sortIcon"
                  style={{ margin: "auto" }}
                >
                  Expired Date{" "}
                  {flag.coupon_end_date === 0 ? (
                    <FaSort />
                  ) : flag.coupon_end_date === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button>
              </th>
              <th>Featured</th>
              <th
                onClick={() => HandleSortCol("status_name")}
                style={{ borderTopRightRadius: "15px", textAlign: "center" }}
              >
                <Button
                  className="btn btn-primary sortIcon"
                  style={{ margin: "auto" }}
                >
                  Status{" "}
                  {flag.status_name === 0 ? (
                    <FaSort />
                  ) : flag.status_name === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {!ShowTable ? (
              TableRows.map((item, key) => (
                <tr key={item.city_coupon_id || key}>
                  <td className="radio-colors">
                    <Form.Check
                      aria-label="row-checkbox"
                      className="orange-checkbox"
                      onChange={(e) => handleClick(e, item.city_coupon_id)}
                      checked={isCheck.includes(item.city_coupon_id)}
                    />
                  </td>
                  <td style={{ textAlign: "left" }}>
                    <Link
                      className="vouname-blue"
                      to={`/coupons/couponsDetails/${item.city_coupon_id}`}
                      title={item.coupon_name}
                    >
                      {item.coupon_name?.length > 50
                        ? item.coupon_name.substring(0, 50) + "..."
                        : item.coupon_name}
                    </Link>
                  </td>
                  <td style={{ textAlign: "left" }}>{item.business_name}</td>
                  <td style={{ textAlign: "center" }}>{item.coupon_code}</td>
                  <td style={{ textAlign: "center" }}>{item.coupon_source}</td>

                  <td
                    className="date-col text-center"
                    style={{ textAlign: "center" }}
                  >
                    {FormatDateShortMonth(item.created_at)}
                  </td>
                  <td
                    className="date-col text-center"
                    style={{ textAlign: "center" }}
                  >
                    {FormatDateShortMonth(item.expiry_date)}
                  </td>
                  <td>
                    <Switch
                      className="switch-button"
                      checkedChildren="Enable"
                      unCheckedChildren="Disable"
                      disabled={
                        item.status_name !== "Published" ? disabled : !disabled
                      }
                      checked={
                        featureStatus[item.city_coupon_id] ||
                        item.is_featured === true
                      }
                      onChange={(checked) => {
                        handleFeatureStatus(
                          checked,
                          item.city_coupon_id,
                          item.business_id,
                          item.marketplace_business_id,
                          "feature-toggle",
                        );
                      }}
                    />
                  </td>

                  <td style={{ textAlign: "center" }}>
                    <Form.Select
                      aria-label="Default select example"
                      className="table-select status_select"
                      value={item.status_id}
                      onChange={(e) => handleChangeDropDown(e, key)}
                      style={{ margin: "auto" }}
                    >
                      {item.status_list?.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.status}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="toggle-row">
                <td colSpan="9">
                  <p className="noData">{NoDataText.ErrText}</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {TableRows.length !== 0 && (
        <Pagination
          totalPageCount={totalPageCount}
          setPageNumber={setPageNumber}
          limit={limit}
        />
      )}
    </>
  );
};

export default ManageCoupons;